'use client'

import { useUserQuery } from '@/hooks/react-query/user/use-user'
import { RANKING_LABEL_VN } from '@/types/auth'
import { sendGTMEvent } from '@next/third-parties/google'
import { generateUUID } from '../utils/crypto'
import { ETrackingEvent } from './type'

type TrackEventData<
  T extends Record<string, unknown> = Record<string, unknown>,
> = {
  event: ETrackingEvent
  user_id?: string
  user_type?: string
} & T

export function useTrackEvent<T>() {
  const { data: user } = useUserQuery()
  return (data: TrackEventData & T) => {
    sendGTMEvent({
      ...data,
      frontend_version: '69',
      user_id: user?.id,
      user_type: user?.ranking?.ranking_id
        ? RANKING_LABEL_VN[user.ranking.ranking_id]
        : '',
      unique_event_id: generateUUID(),
    })
  }
}
